export default __webpack_public_path__ + "static/media/bottom_left_to_top_right_scaller.0e2c27db.svg";